export default __webpack_public_path__ + "static/media/logoI4U.0b3f1cb5.png";